const autonomeOrigins = process.env.REACT_APP_AUTONOME_ORIGINS?.split(',') || [];

export const isAutonomeOrigin = autonomeOrigins?.includes(window.location.origin);
